export var createGetActiveAudioWorkletNodeInputs = function createGetActiveAudioWorkletNodeInputs(activeAudioWorkletNodeInputsStore, getValueForKey) {
  return function (nativeAudioWorkletNode) {
    return getValueForKey(activeAudioWorkletNodeInputsStore, nativeAudioWorkletNode);
  };
};